import mapBaseAttachmentDesc from './mapBaseAttachmentDesc';
import { AttachmentDesc } from '90.quickConnect.Models/models';

const mapAttachmentDesc = (field: AttachmentDesc): AttachmentDesc =>
  ({
    ...mapBaseAttachmentDesc(field),
  } as AttachmentDesc);

export default mapAttachmentDesc;
